import React from 'react';
import MasterMultiImagePicker from './MasterMultiImagePicker';

const MasterImagePicker = ({ value, onChange }) => {
  return (
    <MasterMultiImagePicker
      value={value ? [value] : []}
      maxPhotos={1}
      onChange={(images) => onChange?.((images || [])[0] || null)}
    />
  );
};

export default MasterImagePicker;
